import styled from "styled-components";

export const BalanceContent = styled.div`
  position: relative;
  top: -12px;
  margin: 0 auto;
  font-size: 16px;

  span {
    color: #05dc7f;
    font-size: 18px;
    font-weight: bold;
  }
`;
